var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "previsioni" }, [
        _c("div", { staticClass: "risultato font-hemi-head" }, [
          _c("span", { staticClass: "spesa" }, [
            _vm._v(_vm._s(_vm.previsioneSpesa)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "crediti-lega" }, [
            _vm._v("/ " + _vm._s(_vm.creditiLega)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "consiglio" },
          [
            _c(
              "v-btn",
              {
                staticClass: "navy darken-2 mr-1 py-3",
                attrs: { "x-small": "", depressed: "" },
                on: { click: _vm.promptDialogPlanSettings },
              },
              [
                _c(
                  "v-icon",
                  { staticClass: "white--text", attrs: { small: "" } },
                  [_vm._v("settings")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "testoConsiglio",
                class:
                  ((_obj = {}),
                  (_obj[_vm.tipoConsiglio] = _vm.tipoConsiglio),
                  (_obj[_vm.effectConsiglio] = _vm.effectConsiglio),
                  _obj),
              },
              [_vm._v("\n        " + _vm._s(_vm.consiglio) + "\n      ")]
            ),
            _vm._v(" "),
            _vm.actionConsiglio
              ? _c(
                  "div",
                  { staticClass: "actionConsiglio ml-1" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "secondary--text navy darken-2 mr-1 py-3",
                        attrs: { depressed: "", "x-small": "" },
                        on: { click: _vm.actionConsiglio },
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.actionConsiglioIcon,
                                expression: "actionConsiglioIcon",
                              },
                            ],
                            attrs: { small: "" },
                          },
                          [_vm._v(_vm._s(_vm.actionConsiglioIcon))]
                        ),
                        _vm._v(
                          "\n          " + _vm._s(_vm.actionConsiglioText)
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            "retain-focus": false,
            "hide-overlay": "",
          },
          model: {
            value: _vm.dialogTogliereCrediti,
            callback: function ($$v) {
              _vm.dialogTogliereCrediti = $$v
            },
            expression: "dialogTogliereCrediti",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "navy pa-4" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "navy white--text pt-2 px-2 d-flex align-center font-hemi-head",
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "white--text", attrs: { left: "" } },
                    [_vm._v("bolt")]
                  ),
                  _c("span", { staticStyle: { "font-size": "18px" } }, [
                    _vm._v("Correzione veloce"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { depressed: "", icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogTogliereCrediti = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list",
                {
                  staticClass: "recycle-scroller py-4",
                  class: { "nice-scroll": !_vm.is_mobile },
                },
                _vm._l(_vm.planConsiglio, function (ruoloData, ruolo_abc) {
                  return _c(
                    "div",
                    { key: ruolo_abc },
                    _vm._l(ruoloData, function (slotData, slot, i) {
                      return _c(
                        "div",
                        { key: ruolo_abc + "_" + slot },
                        [
                          _c("asta-slot", {
                            attrs: {
                              ruolo_abc: ruolo_abc,
                              iSlot: slot,
                              i: i,
                              readonly: "",
                              append:
                                _vm.planConsiglio[ruolo_abc][slot].crediti,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "justify-center pt-4" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "secondary",
                      attrs: { rounded: "" },
                      on: { click: _vm.correzioneVeloce },
                    },
                    [_vm._v("Ok")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "secondary--text",
                      attrs: { rounded: "", outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogTogliereCrediti = false
                        },
                      },
                    },
                    [_vm._v("No, correggo a mano")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }